<template>
  <div v-if="!isLoading">
    <div class="pl-4 pt-3 pb-3" v-if="phoneNumber">
      <h3>
        <b>Thông tin người gọi</b>
      </h3>
      <v-layout row wrap>
        <v-flex xs6 class="label pt-2">
          <v-icon>person</v-icon>
          <a
            :href="`http://vmcrm.quanlyxe.vn/index.php?module=Accounts&action=DetailView&record=${dataContact && dataContact.Id}`"
            target="_blank"
          >Name: {{dataContact && dataContact.LastName}} {{dataContact && dataContact.FirstName}}</a>
        </v-flex>
        <v-flex xs6 class="label pt-2">
          <v-icon>pin_drop</v-icon>
          Tracking Account: {{dataContact && dataContact.TrackingId}}
        </v-flex>
        <v-flex xs6 class="label pt-2">
          <v-icon>phone</v-icon>
          Office Phone: {{dataContact && dataContact.OfficePhone }}
        </v-flex>
        <v-flex xs6 class="label pt-2">
          <v-icon>location_on</v-icon>
          Billing Address: {{dataContact && dataContact.Address}}
        </v-flex>
        <v-flex xs6 class="label pt-2">
          <v-icon>contact_mail</v-icon>
          Primary Contact Email: {{dataContact && dataContact.Email}}
        </v-flex>
        <v-flex xs6 class="label pt-2">
          <v-icon>person</v-icon>
          Department: {{dataContact && dataContact.Department}}
        </v-flex>
      </v-layout>
    </div>

    <v-divider v-if="phoneNumber" class="pb-5"></v-divider>

     <crm-contacts
      :isLoading="isLoadingContacts"
      :datasource="contacts"
      class="crm-contact"
    ></crm-contacts>

    <v-divider></v-divider>
    <crm-tickets :isLoading="isLoadingTickets" :datasource="tickets"></crm-tickets>

    <v-divider></v-divider>
  </div>
  <div v-else>
    <loading-panel></loading-panel>
  </div>
</template>

<script>
import LoadingPanel from './LoadingPanel';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import CrmTickets from './CrmTickets';
import CrmContacts from './CrmContacts';

export default {
  components: {
    LoadingPanel,
    CrmTickets,
    CrmContacts
  },

  props: {
    trackingId: Number,
    phoneNumber: {
      type: String,
      default: null
    }
  },

  data: () => ({
    account: null,
    isLoading: false,
    isLoadingTickets: false,
    isLoadingContacts: false,
    tickets: [],
    contacts: [],
    dataContact: null // Thông tin contact đang gọi đến
  }),

  created () {
    this.getContacts();
    this.getTickets();
  },

  
  methods: {
    ...mapActions(['BitrixContactsRequest', 'BitrixTicketsRequest']),

    async getContacts () {
      this.isLoadingContacts = true;
      let res = await this.BitrixContactsRequest({ trackingId: this.trackingId }).catch(_ => {
        return [];
      });
      console.log('getContacts -> res', res);
      this.isLoadingContacts = false;

      this.contacts = res;
      this.dataContact = this.phoneNumber && this.contacts && this.contacts.find(item => item.MobilePhone.includes(this.phoneNumber) || item.OfficePhone.includes(this.phoneNumber));
    },

    async getTickets () {
      this.isLoadingTickets = true;
      let res = await this.BitrixTicketsRequest({ trackingId: this.trackingId }).catch(_ => {
        return [];
      });
      this.isLoadingTickets = false;

      this.tickets = res;
    }
  }
};
</script>

<style scoped>
.crm-contact >>> .pt-5{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/components/CrmBitrix.vue